import { createStateHook } from 'react-sweet-state';

import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

export const useNotification = createStateHook(store, {
	selector: (state: IssueAdjustmentsState) => state.notification,
});
